import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { ReceiptIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';

import Grid from '@mui/material/Grid';

const SpotQuotesSidebar: FC = () => {
  const location = useLocation();

  const navigationItems = [];

  navigationItems.push({
    label: 'Spot Quotes',
    url: '/spot_quotes',
    icon: ReceiptIcon as any,
    matches: true,
    subNavigationItems: [
      {
        url: '/spot_quotes',
        disabled: false,
        label: 'XOI Jobs',
      },
    ],
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Navigation location={location.pathname}>
          <Navigation.Section items={navigationItems} />
        </Navigation>
      </Grid>
    </Grid>
  );
};

export default SpotQuotesSidebar;
